<template>
    <div id="app">
        <div class="wrapper" v-if="user">
            <app-header :user="user" />
            <admin-template>
                <transition>
                    <keep-alive>
                        <router-view></router-view>
                    </keep-alive>
                </transition>
            </admin-template>
        </div>

        <div class="login" v-else>
            <app-header :user="user" />
            <transition>
                <keep-alive>
                    <router-view></router-view>
                </keep-alive>
            </transition>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import AppHeader from "./components/AppHeader.vue";
import AdminTemplate from "./components/AdminTemplate.vue";

export default {
    name: "app",
    components: {
        AppHeader,
        AdminTemplate,
    },
    computed: {
        ...mapState(["user", "employee"]),
    },
    watch: {
        user() {},
    },
};
</script>

<style lang="scss">
@import "/sass/app";

* {
    margin: auto;
    padding: 0 0 0 0;
}

#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
}
</style>
